module.exports = __webpack_public_path__ + "images/loadergif_29602dc.svg";